import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { routeUrl, routeUrlNoSider, catchRouteUrl } from './routeUrl';
import zhCN from 'antd/lib/locale/zh_CN';
import BaseRoute from 'components/BaseRoute';
import { ConfigProvider } from 'antd';

// TODO: 上线后需要修改
export const baseUrl = process.env.NODE_ENV === 'development' ? '/' : '/';

const AppRouter = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter basename={baseUrl}>
        <BaseRoute routeUrl={routeUrl} routeUrlNoSider={routeUrlNoSider} catchRouteUrl={catchRouteUrl} />
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default AppRouter;
